export default __webpack_public_path__ + "static/media/Harriet_Owusu_AHV_In_Moms_We_Trust.79fe5fb4.jpg";